import { render, staticRenderFns } from "./RouteCreate.vue?vue&type=template&id=44da952b&scoped=true&"
import script from "./RouteCreate.vue?vue&type=script&lang=js&"
export * from "./RouteCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44da952b",
  null
  
)

export default component.exports